<template>
  <div class="flex items-center">
    <!-- {{params}} -->
    <div class="text-inherit" v-if="params.data.level != '4'">{{params.value}}</div>
    <router-link :to="url" @click.stop.prevent class="text-primary hover:text-primary" v-else>{{ params.value }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
    url () {
      return '/apps/user/user-view/268'

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
}
</script>
